import { Route, Redirect } from "react-router-dom";
import { ONBORADING_SCREEN } from "./Constants";
import auth from "../services/accountService";

const ProtectedRoute = ({ path, component: Component, render, ...rest }: any) => {
    return (
        <Route
            {...rest}
            render={props => {
                if (!auth.getCurrentUser())
                    return (
                        <Redirect
                            to={{
                                pathname: ONBORADING_SCREEN,
                                state: { from: props.location }
                            }}
                        />
                    );
                return Component ? <Component {...props} /> : render(props);
            }}
        />
    );
};

export default ProtectedRoute;
